import { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { GetEquipamentoMedicaoListaRequest, GetEquipamentoMedicaoListaResponse } from "../daos/read/equipamento_medicao_list";
import { IEquipamentoMedicaoService } from "./equipamentoMedicaoService";
import { CreateEquipamentoMedicaoRequest, CreateEquipamentoMedicaoResponse } from "../daos/create/equipamento_medicao_create";
import { GetEquipamentoMedicaoByIdRequest, GetEquipamentoMedicaoByIdResponse } from "../daos/read/equipamento_medicao_get_by_id";
import { UpdateEquipamentoMedicaoRequest, UpdateEquipamentoMedicaoResponse } from "../daos/update/equipamento_medicao_update";
import { GetAllIndicadoresResponse } from "../daos/read/get_all_indicadores";
import { EquipamentoMedIndicadores } from "../../domain/models/EquipamentoMed_indicadores";
import { DownloadEquipamentoMedicaoArquivoRequest } from "../daos/read/download_equipamento_medicao_arquivo";
import { GetAllEquipamentoMedicaoHistoricoRequest, GetAllEquipamentoMedicaoHistoricoResponse } from "../daos/read/get_all_equipamento_medicao_historico";
import { CreateCadastroCoresRequest, CreateCadastroCoresResponse } from "../daos/create/create_cadastro_cores";
import { DeleteCadastroCoresRequest, DeleteCadastroCoresResponse } from "../daos/delete/delete_cadastro_cores";
import { GetAllCadastroCoresRequest, GetAllCadastroCoresResponse } from "../daos/read/get_all_cadastro_cores";
import { GetCadastroCoresByIdRequest, GetCadastroCoresByIdResponse } from "../daos/read/get_cadastro_cores_by_id";
import { UpdateCadastroCoresRequest, UpdateCadastroCoresResponse } from "../daos/update/update_cadastro_cores";
import { dataPeriodoApi } from '../../domain/models/periodo_anual';


export class EquipamentoMedicaoService implements IEquipamentoMedicaoService {

  async getAllEquipamentoMedicaoLista(request: GetEquipamentoMedicaoListaRequest)
    : Promise<GetEquipamentoMedicaoListaResponse> {
    try {
      const result = await axiosInstance({}).post(`/equipamentomedicao/all`, request);
      const response = handleAxiosResponse<GetEquipamentoMedicaoListaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createEquipamentoMedicao(request: CreateEquipamentoMedicaoRequest): Promise<CreateEquipamentoMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/equipamentomedicao/create`, request);
      const response = handleAxiosResponse<CreateEquipamentoMedicaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteEquipamentoMedicaoById(idEquipamentoMedicao: number): Promise<void> {
    try {
      const result = await axiosInstance({}).delete(`/equipamentomedicao/delete/${idEquipamentoMedicao}`);
      handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getEquipamentoMedicaoById(request: GetEquipamentoMedicaoByIdRequest): Promise<GetEquipamentoMedicaoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/equipamentomedicao/${request.idEquipamentoMedicao}`);
      const response = handleAxiosResponse<GetEquipamentoMedicaoByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateEquipamentoMedicao(request: UpdateEquipamentoMedicaoRequest): Promise<UpdateEquipamentoMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/equipamentomedicao/update`, request);
      const response = handleAxiosResponse<UpdateEquipamentoMedicaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#region Principal
  async getAllIndicadores(): Promise<GetAllIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).get("/equipamentomedicao/indicadores");
      const rawData = handleAxiosResponse<EquipamentoMedIndicadores>(result);
      const response: GetAllIndicadoresResponse = {
        indicadores: rawData
      };
      return response;

    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  async downloadEquipamentoMedicaoArquivo({ idEquipamentoMedicao, nroArquivo }: DownloadEquipamentoMedicaoArquivoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({}).get(`/equipamentomedicao/${idEquipamentoMedicao}/download/${nroArquivo}`, { responseType: 'blob' });
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllEquipamentoMedicaoHistorico({ idEquipamentoMedicao }: GetAllEquipamentoMedicaoHistoricoRequest): Promise<GetAllEquipamentoMedicaoHistoricoResponse> {
    try {
      const result = await axiosInstance({}).get(`/equipamentomedicao/${idEquipamentoMedicao}/historico`);
      const response = handleAxiosResponse<GetAllEquipamentoMedicaoHistoricoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllCadastroCores(request: GetAllCadastroCoresRequest): Promise<GetAllCadastroCoresResponse> {
    try {
      const result = await axiosInstance({}).post(`/equipamentomedicao/cores`, {
        ...request,
        dataInicio: dataPeriodoApi(request.dataInicio),
        dataTermino: dataPeriodoApi(request.dataTermino),
      });
      const response = handleAxiosResponse<GetAllCadastroCoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCadastroCoresById({ idCadastroCor }: GetCadastroCoresByIdRequest): Promise<GetCadastroCoresByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/equipamentomedicao/cores/${idCadastroCor}`);
      const response = handleAxiosResponse<GetCadastroCoresByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createCadastroCores(request: CreateCadastroCoresRequest): Promise<CreateCadastroCoresResponse> {
    try {
      const result = await axiosInstance({}).post(`/equipamentomedicao/cores/create`, {
        ...request,
        dataInicio: dataPeriodoApi(request.dataInicio),
        dataFinal: dataPeriodoApi(request.dataFinal),
      });
      const response = handleAxiosResponse<CreateCadastroCoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateCadastroCores({ idCadastroCor, ...request }: UpdateCadastroCoresRequest): Promise<UpdateCadastroCoresResponse> {
    try {
      const result = await axiosInstance({}).post(`/equipamentomedicao/cores/${idCadastroCor}/update`, {
        ...request,
        dataInicio: dataPeriodoApi(request.dataInicio),
        dataFinal: dataPeriodoApi(request.dataFinal),
      });
      const response = handleAxiosResponse<UpdateCadastroCoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteCadastroCores({ idCadastroCor }: DeleteCadastroCoresRequest): Promise<DeleteCadastroCoresResponse> {
    try {
      const result = await axiosInstance({}).delete(`/equipamentomedicao/cores/${idCadastroCor}/delete`);
      const response = handleAxiosResponse<DeleteCadastroCoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}
